import { useState } from "react";
import { post } from "../networking/RequestService";
import { apiErrorText } from "app/popleads/networking/apiErrorText";

function useChangeProfileContactedStatus() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const changeContactedStatus = async (params = {}) => {
        setLoading(true);
        setError(null);

        if (!params.profileId || !params.status) {
            const errorMessage = "Missing required parameters";
            setError(errorMessage);
            setLoading(false);
            return { error: errorMessage };
        }

        try {
            const response = await post({
                fn: "changeProfileContactedStatus",
                profileId: params.profileId,
                status: params.status,
            });
            return { data: response.data };
        } catch (error) {
            const errorMessage = apiErrorText(error);
            setError(errorMessage);
            return { error: errorMessage };
        } finally {
            setLoading(false);
        }
    };

    return { changeContactedStatus, loading, error };
}

export default useChangeProfileContactedStatus;
